<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    @cancel="handleCancel"
    :footer="null"
    cancelText="关闭">

    <div>
<!--      <span :id="'t'+item.id"-->
<!--            class="template-span"-->
<!--            :data-clipboard-text="item.contentStr" v-if="list" v-for="item in list">-->
<!--        {{item.templateName}}-->
<!--        <a-icon type="edit" @click.stop="editTemplate(item)" style="margin-left: 10px;"></a-icon>-->
<!--      </span>-->
      <div v-if="list" v-for="item in list" class="template-list" :id="'t'+item.id" :data-clipboard-text="item.contentStr" style="cursor: pointer;">
        <div >
          <div class="template-title">
            {{item.templateName}}
          </div>
          <div  class="template-content">
            {{item.contentStr}}
          </div>
        </div>
        <div>
          <a-icon type="edit" @click.stop="editTemplate(item)"   class="template-btn"></a-icon>
        </div>
      </div>
      <a-button type="primary" @click="addTemplate">添加模板</a-button>
    </div>
    <add-template-modal ref="addTm" @ok="loadList"></add-template-modal>
  </j-modal>
</template>

<script>
import {getAction, httpAction,deleteAction} from '@/api/manage'
import {initDictOptions, filterDictText} from '@/components/dict/JDictSelectUtil'
import AddTemplateModal from "@comp/dm/workorder/modal/AddTemplateModal.vue";
import Clipboard from 'clipboard'
export default {
  name: 'TemplateModal',
  components: {
    AddTemplateModal

  }, props: {
    dictOptions:{
      type:Object,
      default:{}
    }
  },

  data () {
    return {
      title:'',
      width:600,
      visible: false,
      orderId:'',
      list:[],
      businessSegment:''
    }
  },
  methods: {
    show (businessSegment,orderId) {
      this.businessSegment = businessSegment;
      this.title = this.customRender(businessSegment,'business_segment')+"自定义模板"
      this.orderId = orderId
      this.visible=true;
      this.loadList();
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    handleCancel () {
      this.close()
    },customRender(text,dict){
      //字典值替换通用方法
      return filterDictText(this.dictOptions[dict], text);
    },loadList(){
      if(this.list){
        this.list.forEach(item=>{
          if(item.clipboard){
            item.clipboard.destroy();
          }
        });
      }
      this.list = []
      getAction('/dm/dmWorkOrderTemplate/listByOrderId',{orderId:this.orderId}).then(res=>{
        if(res.success){
          this.list = [
            ...res.result
          ];
          this.$nextTick( ()=> {
            this.list.forEach(item=>{
              item.clipboard = new Clipboard(`#t${item.id}`);
              item.clipboard.on('success', (e) => {
                this.$message.success("复制成功!");
              });
            })
          })

        }
      })
    },addTemplate(){
      this.$refs.addTm.add(this.businessSegment);
    },afterClose(e){
      deleteAction('/dm/dmWorkOrderTemplate/delete',{id:e.id}).then(res=>{
        if(res.success){
          this.$message.success("删除成功!");
        }
      })
    },editTemplate(record){
      this.$refs.addTm.edit(record);
    }
  }
}
</script>
<style lang="less" scoped>
  .template-span{
    padding: 12px;
    margin-right: 20px;
    border: 1px solid #00A0E9;
    cursor: pointer;
    color: #00A0E9;
    background-color: #fefefe;
    border-radius: 3px;
  }

  .template-list{
    display: flex;
    justify-content: space-between;
    border-radius: 10px;
    border: 1px solid #00a0e9;
    margin-bottom: 20px;
    padding: 10px;
  }
  .template-title{
    font-size: 16px;
    font-weight: bold;
  }
  .template-content{
    white-space: pre-line; /* 关键属性 */
    margin-top: -20px;
  }
  .template-btn{
    margin-left: 10px;color: #00A0E9;
    cursor: pointer;
  }
</style>